import { Children, cloneElement, createElement, isValidElement } from 'react';

const textOf = (node) => {
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (!isValidElement(node)) return '';
  return Children.toArray(node.props.children).map(textOf).join(' ').replace(/\s+/g, ' ').trim();
};

const mapElements = (children, transform) =>
  Children.map(children, (child) => {
    if (!isValidElement(child)) return child;
    if (typeof child.type === 'symbol') {
      return cloneElement(child, {}, mapElements(child.props.children, transform));
    }
    return transform(child);
  });

const hasControl = (node) => {
  if (!isValidElement(node)) return false;
  return (
    ['input', 'select', 'textarea', 'button'].includes(node.type) ||
    typeof node.props.onChange === 'function' ||
    Children.toArray(node.props.children).some(hasControl)
  );
};

export const prepareResponsiveTable = (children) => {
  const headers = [];
  mapElements(children, (section) => {
    if (section.type === 'thead') {
      mapElements(section.props.children, (row) => {
        if (row.type === 'tr') {
          mapElements(row.props.children, (cell) => {
            if (cell.type === 'th') {
              for (let column = 0; column < (cell.props.colSpan || 1); column += 1) {
                headers.push(textOf(cell));
              }
            }
            return cell;
          });
        }
        return row;
      });
    }
    return section;
  });

  return mapElements(children, (section) => {
    if (!['tbody', 'tfoot'].includes(section.type)) return section;

    return cloneElement(
      section,
      {},
      mapElements(section.props.children, (row) => {
        if (row.type !== 'tr') return row;
        let column = 0;
        return cloneElement(
          row,
          {},
          mapElements(row.props.children, (cell) => {
            if (!['td', 'th'].includes(cell.type)) return cell;
            const span = cell.props.colSpan || 1;
            const label = cell.props['data-label'] || (span === 1 ? headers[column] : '') || '';
            column += span;
            return cloneElement(
              cell,
              {
                'data-label': label,
                'data-mobile-stack': span > 1 || hasControl(cell) ? 'true' : undefined,
              },
              createElement('div', { className: 'cms-cell-value' }, cell.props.children)
            );
          })
        );
      })
    );
  });
};
